import { ComponentFieldHandler } from "./ComponentFieldHandler";
import { NumberFiled } from "./Filed/NumberFiled";

export const ComponentFieldMapping: { [key: string]: ComponentFieldHandler<any> } = {
    "number": new NumberFiled("number"),
}